import Checkbox from "react-custom-checkbox";
import { ReactComponent as Stroke } from "../../assets/images/checkbox-stroke.svg";

type PropsType = {
  label?: string | React.ReactNode;
  checked?: boolean;
  onChange?(check: boolean): void;
  className?: string;
};

const BaseCheckbox = (props: PropsType) => {
  const { label, checked, onChange, className } = props;

  const handleChange = (check: boolean) => {
    onChange && onChange(check);
  };

  return (
    <Checkbox
      checked={checked}
      onChange={handleChange}
      borderColor="var(--color-3)"
      borderWidth="1px"
      borderRadius="1px"
      size={20}
      icon={<Stroke />}
      label={label}
      labelStyle={{
        paddingLeft: ".5rem",
        fontSize: "14px",
      }}
      containerStyle={{
        userSelect: "none",
      }}
      containerClassName={className}
    />
  );
};

export default BaseCheckbox;
